module.exports = __webpack_public_path__ + "static/media/take-challenge-popup-male-image.04b5ed81.png";